"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkoutStorePopupClickCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var checkoutStorePopupClickCreator = function (event) {
    var _a;
    var eventData = {
        action: analytics_layer_1.PopupLoadEventNames.CheckoutStorePopup,
        event: 'popup-click',
        eventInfo: 'popup-click',
        popup: {
            name: event.eventData.popup.name || consts_1.NOT_AVAILABLE,
            time: event.eventData.popup.time || consts_1.NOT_AVAILABLE,
            optionSelected: event.eventData.popup.optionSelected || consts_1.NOT_AVAILABLE,
        },
        cart: {
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); }),
            checkoutType: ((_a = event.eventData.cart) === null || _a === void 0 ? void 0 : _a.checkoutType) || consts_1.DEFAULT_CHECKOUT_TYPE,
        },
    };
    return eventData;
};
exports.checkoutStorePopupClickCreator = checkoutStorePopupClickCreator;
